module.exports = __webpack_public_path__ + "static/media/matching-score-back.de3426ab.png";